var ReactRedux = require("react-redux");
var bindActionCreators = require("redux").bindActionCreators;
var authActions = require('../../../modules/auth/actions/auth-login');
var specialistsActions = require('../../../modules/specialists/actions/specialists');
var specialistActions = require('../../../modules/specialists/actions/specialist');
var findASpecialistMetaActions = require('../../../modules/meta/actions/find-a-specialist');
var FindASpecialist = require('../components/find-a-specialist.jsx');

var mapStateToProps = function(state){
  return {
      auth: state.auth,
      specialists: state.specialists,
      specialist: state.specialist
  };
};

var mapDispatchToProps = function(dispatch) {
	return bindActionCreators(Object.assign({}, authActions, specialistsActions, specialistActions, findASpecialistMetaActions), dispatch);
}

module.exports = ReactRedux.connect(mapStateToProps, mapDispatchToProps)(FindASpecialist);



// WEBPACK FOOTER //
// ./src/common/routes/find-a-specialist/containers/find-a-specialist.jsx